module.exports = __webpack_public_path__ + "static/media/ConpamyProfile_white.0fd14732.svg";